import axios from 'axios';

export const supportApi = axios.create({ baseURL: '/support-api' });
